// extracted by mini-css-extract-plugin
export var checkmark = "FeatureList-module--checkmark--BJ4rh";
export var cta = "FeatureList-module--cta--RQPiL";
export var feature = "FeatureList-module--feature--2HhFG";
export var grid = "FeatureList-module--grid--+J6vW";
export var img = "FeatureList-module--img--0E9eG";
export var title = "FeatureList-module--title--sB1Mb";